import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('marketingSmsManagementStore', 'marketingSmsTemplateStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()

  componentDidMount() {
  }

  handleSearch = () => {
    const {marketingSmsTemplateStore, accountStore, marketGroupId, type} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'templateContent': fieldsValue.templateContent,
        'templateType': type,
        'marketGroupId': marketGroupId,
        'status': '1',
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      marketingSmsTemplateStore.onSearchAction(params)
    }).catch(err => {
    })
  }

  render() {
    const {t} = this.props
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm">
          <Row gutter={[10, 10]}>
            <Col span={6}>
              <Form.Item name="templateContent"
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.keywords`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={18}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export default withTranslation()(SearchForm)
